﻿import React from 'react';
import { connect } from 'react-redux';
import { fetchWizardQuestionsData, submitWizardFormDataAction } from '../State/actions';

import { Wizard } from 'react-use-wizard';
import { AnimatePresence } from 'framer-motion';

import WizardQuestion from './WizardQuestion';
import WizardFinal from './WizardFinal';
import WizardAnimation from './WizardAnimation';


const WizardBase = (props) => {

    const [questions, setQuestions] = React.useState([]);

    const [formState, setFormState] = React.useState({
        answers: []
    });

    const previousStep = React.useRef(0);

    React.useEffect(() => {
        props.loadQuestions();
    }, []);

    const questionGroups = props.wizardData.questions;
     
    React.useEffect(() => {
        if (questionGroups) {
            questionGroups.map((sections, i) => {

                sections.questions.map((question, index) => {
                    setQuestions(questions => [...questions, question]);
                })
            })
        }

    }, [questionGroups])


    const handleSubmit = () => {

        //clean undefined and null values
        let formData = Object.entries(formState).reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {});
        props.submitForm(formData);

        dataLayer.push({ 'event': 'customer_knowledge_survey_complete' });
    };

    const totalQuestions = questions.length;

    return (
        <React.Fragment>
            <AnimatePresence>

                <Wizard>

                    {
                        questions.length > 0 &&
                        questions.map((question, index) => {
                            return (
                                <form
                                    key={index}
                                    className="wizard">

                                    <WizardAnimation previousStep={previousStep}>

                                        <WizardQuestion
                                            totalQuestions={totalQuestions}
                                            key={index}
                                            question={question}
                                            state={{ form: [formState, setFormState] }} />

                                     </WizardAnimation>
                                 </form>
                            )
                        })
                    }

                    {questions.length > 0 &&
                        <WizardFinal handleSubmit={handleSubmit} />
                    }                    
                </Wizard>
            
            </AnimatePresence>
        </React.Fragment>
    )
}

// state

const mapStateToProps = (state) => {
    return {
        wizardData: state.wizardData,
        formData: state.formData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadQuestions: (wizardData) => dispatch(fetchWizardQuestionsData(wizardData)),
        submitForm: (formData) => dispatch(submitWizardFormDataAction(formData))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardBase);

